import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const CarInfoIcon = ({ width = 56, height = 56 }: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="28"
        cy="28"
        r="26"
        fill="#0D2E68"
        stroke="url(#paint0_linear)"
        strokeWidth="4"
      />
      <g clipPath="url(#clip0)">
        <path
          d="M41.1298 25.1L40.3834 23.234L39.0599 19.925C37.9237 
          17.0848 35.2136 15.25 32.1543 15.25H23.7207C20.662 15.25 
          17.9513 17.0848 16.8151 19.925L15.4916 23.234L14.7452 
          25.1C13.1435 25.709 12 27.247 12 29.0625V32.25C12 33.3205 
          12.4091 34.2867 13.0625 35.0344V38.625C13.0625 39.7984 14.0141 40.75 
          15.1875 40.75H17.3125C18.4859 40.75 19.4375 39.7984 19.4375 
          38.625V36.5H36.4375V38.625C36.4375 39.7984 37.3891 40.75 38.5625 
          40.75H40.6875C41.8609 40.75 42.8125 39.7984 42.8125 38.625V35.0344C43.4659 
          34.2873 43.875 33.3211 43.875 32.25V29.0625C43.875 27.247 42.7315 25.709 
          41.1298 25.1ZM20.761 21.5035C21.2451 20.2936 22.4171 19.5 23.7207 19.5H32.1543C33.4579 
          19.5 34.6299 20.2936 35.114 21.5035L36.4375 24.8125H19.4375L20.761 21.5035ZM17.3125 
          32.2367C16.0375 32.2367 15.1875 31.3894 15.1875 30.1184C15.1875 28.8473 16.0375 28 
          17.3125 28C18.5875 28 20.5 29.9065 20.5 31.1775C20.5 32.4486 18.5875 32.2367 17.3125 
          32.2367ZM38.5625 32.2367C37.2875 32.2367 35.375 32.4486 35.375 31.1775C35.375 29.9065 
          37.2875 28 38.5625 28C39.8375 28 40.6875 28.8473 40.6875 30.1184C40.6875 31.3894 
          39.8375 32.2367 38.5625 32.2367Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="28"
          y1="4"
          x2="28"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.bright_turquoise} />
          <stop offset="1" stopColor="#CEE8FF" />
        </linearGradient>
        <clipPath id="clip0">
          <rect
            width="31.875"
            height="34"
            fill="white"
            transform="translate(12 11)"
          />
        </clipPath>
      </defs>
    </svg>
  </VectorIcon>
);

export default CarInfoIcon;
